export default __webpack_public_path__ + "static/media/task.d7b36673.svg";